var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.willModalOpen
    ? _c(
        "div",
        {
          class: [
            _vm.bemBlockMod(
              ((_obj = {}),
              (_obj[_vm.modalModifier] = _vm.modalModifier),
              (_obj.open = _vm.isModalOpen),
              _obj)
            )
          ],
          attrs: {
            role: "dialog",
            "data-allow-multiple-modals": "true",
            tabindex: "-1"
          }
        },
        [
          _c(
            "div",
            {
              class: _vm.bemElement("dialog", "scrollable"),
              attrs: { role: "document" }
            },
            [
              _c("div", { class: _vm.bemElement("content") }, [
                _c(
                  "div",
                  { class: _vm.bemElement("header") },
                  [
                    _vm.hasBackButton
                      ? _c(
                          "button",
                          {
                            class: [
                              _vm.bemElement("btn-back"),
                              "btn",
                              "btn--back"
                            ],
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.close($event)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$msg("header.back", "header")) +
                                "\n        "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasMiniCart ? _c("BaseMinicart") : _vm._e(),
                    _vm._v(" "),
                    _vm.hasCloseButton
                      ? _c(
                          "button",
                          {
                            class: [
                              _vm.bemElement("close"),
                              "btn-close",
                              "modal-close-action",
                              _vm.smallCloseWithText
                                ? "small-close-with-text"
                                : ""
                            ],
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.close($event)
                              }
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                class: _vm.smallCloseWithText
                                  ? "btn btn-close-text"
                                  : "visually-hidden"
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$msg("global.close", "locale")) +
                                    "\n          "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "body",
                    class: _vm.bemElement("body"),
                    on: { "scrollable-elements:update": _vm.setScrollLocks }
                  },
                  [_vm._t("default")],
                  2
                )
              ])
            ]
          ),
          _vm._v(" "),
          _vm.showBackdrop
            ? _c("div", {
                class: _vm.bemElement("backdrop", {
                  interaction: _vm.closeOnBackdropInteraction
                }),
                on: {
                  click: _vm.handleBackdropInteraction,
                  touchstart: _vm.handleBackdropInteraction
                }
              })
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }